var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockIcon = function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.333A6.667 6.667 0 1 0 14.667 8 6.675 6.675 0 0 0 8 1.333m2.247 8.913a.606.606 0 0 1-.857 0L7.57 8.428A.6.6 0 0 1 7.394 8V4.363a.606.606 0 1 1 1.212 0V7.75l1.64 1.64a.606.606 0 0 1 0 .857"
  })));
};
export default SvgClockIcon;